import Warning from "@/pages/pub/common/warning.pub";
import {onClickSSO} from "@COMPONENTS/common/commonUtil";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import DetailLocalInformation from "@COMPONENTS/product/pages/detailPackage/desktop/DetailLocalInformation";
import * as style from "@COMPONENTS/style/detailpackage/othernotes";
import * as productinformation from "@COMPONENTS/style/detailpackage/productinformation";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {PlusMoreButton} from "@FRAMEWORK/ui/desktop/button";
import {EditorBox} from "@FRAMEWORK/ui/desktop/editor";
import {LineBox, SubTitleWrap} from "@FRAMEWORK/ui/desktop/layout";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";
import useContentsEmergency from "@QUERIES/essential/contents/useContentsEmergency";
import useEventInsurance from "@QUERIES/prdt/event/useEventInsurance";
import useEventNotice from "@QUERIES/prdt/event/useEventNotice";
import React, {useEffect, useRef, useState} from "react";

const NoticeComponent = ({evCd}: {evCd: string}) => {
	const noticeFetch = useEventNotice(evCd);
	const notice = noticeFetch.data?.body;

	const editorWrapRef = useRef(null);
	const targetRef = useRef<HTMLDivElement>(null);
	const [showMore, setShowMore] = useState(false);
	const [activeButton, setActiveButton] = useState(false);
	const elementHeight = showMore ? "auto" : "330px";
	const buttonText = showMore ? "닫기" : "더 보기";

	const handleButton = () => {
		setShowMore(!showMore);
		if (showMore) {
			const position = targetRef.current.getBoundingClientRect().top + window.scrollY - 160;
			window.scrollTo({top: position, behavior: "smooth"});
		}
	};

	useEffect(() => {
		const ElementHight = editorWrapRef.current?.clientHeight;
		if (ElementHight >= 240) {
			setActiveButton(true);
		} else {
			setActiveButton(false);
		}
	});

	return (
		<>
			{notice && (
				<>
					{notice.inclInfo && (
						<>
							<productinformation.SubTitleWrap>
								<SubTitle>포함사항</SubTitle>
							</productinformation.SubTitleWrap>
							<LineBox>
								<EditorBox dangerouslySetInnerHTML={{__html: notice.inclInfo}} />
							</LineBox>
						</>
					)}
					{notice.notinclInfo && (
						<>
							<productinformation.SubTitleWrap>
								<SubTitle>불포함사항</SubTitle>
							</productinformation.SubTitleWrap>
							<LineBox>
								<EditorBox dangerouslySetInnerHTML={{__html: notice.notinclInfo}} />
							</LineBox>
						</>
					)}
					{notice?.poliInfo && (
						<>
							<SubTitleWrap ref={targetRef}>
								<SubTitle>약관 / 취소수수료</SubTitle>
							</SubTitleWrap>
							<LineBox elementHeight={elementHeight}>
								<EditorBox ref={editorWrapRef} dangerouslySetInnerHTML={{__html: notice?.poliInfo}} />
							</LineBox>
							{activeButton && <PlusMoreButton onClick={handleButton}>약관 / 취소수수료 {buttonText}</PlusMoreButton>}
						</>
					)}
				</>
			)}
		</>
	);
};

/**
 * 포함/불포함/약관
 */
const Notice = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="ReferTabs Notice Error">
		<NoticeComponent {...props} />
	</ErrorBoundary>
);

const ReferComponent = ({evCd}: {evCd: string}) => {
	const useNotice = useEventNotice(evCd);
	const notice = useNotice.data?.body;
	return (
		<>
			{notice?.miscInfo && (
				<>
					<SubTitleWrap>
						<SubTitle>참고/전달사항</SubTitle>
					</SubTitleWrap>
					<LineBox>
						<EditorBox dangerouslySetInnerHTML={{__html: notice?.miscInfo}} />
					</LineBox>
				</>
			)}

			{notice?.essenInfo && (
				<>
					<SubTitleWrap>
						<SubTitle>필수사항</SubTitle>
					</SubTitleWrap>
					<LineBox>
						<EditorBox dangerouslySetInnerHTML={{__html: notice?.essenInfo}} />
					</LineBox>
				</>
			)}
		</>
	);
};

/**
 * 참고/전달사항
 */
const Refer = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="ReferTabs Refer Error">
		<ReferComponent {...props} />
	</ErrorBoundary>
);

const ImportanceComponent = ({evCd}: {evCd: string}) => {
	const goodsCd = evCd.split("-")[0];
	const useNotice = useEventNotice(evCd);
	const notice = useNotice.data?.body;
	const useEmergency = useContentsEmergency(goodsCd);
	const emergency = useEmergency.data?.body || [];

	return (
		<>
			{notice?.refeInfo && (
				<>
					<SubTitleWrap>
						<SubTitle>유의사항</SubTitle>
					</SubTitleWrap>
					<LineBox>
						<EditorBox dangerouslySetInnerHTML={{__html: notice?.refeInfo}} />
					</LineBox>
				</>
			)}
			{emergency.length > 0 &&
				emergency.map((item, index) => (
					<React.Fragment key={index}>
						<SubTitleWrap>
							<SubTitle>{item.emerInfoTitle}</SubTitle>
						</SubTitleWrap>
						<LineBox>
							{item.emerInfoConts && <EditorBox dangerouslySetInnerHTML={{__html: item.emerInfoConts}} />}
						</LineBox>
					</React.Fragment>
				))}
			<SubTitleWrap>
				<SubTitle>주의사항</SubTitle>
			</SubTitleWrap>
			<LineBox>
				<Warning />
			</LineBox>
		</>
	);
};

/**
 * 유의사항
 */
const Importance = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="ReferTabs Importance Error">
		<ImportanceComponent {...props} />
	</ErrorBoundary>
);

// const TermsAndCancellationFeeComponent = ({evCd}: {evCd: string}) => {
// 	const useNotice = useEventNotice(evCd);
// 	const notice = useNotice.data?.body;

// 	return (
// 		<>
// 			{notice?.poliInfo && (
// 				<>
// 					<SubTitleWrap>
// 						<SubTitle>약관 / 취소수수료</SubTitle>
// 					</SubTitleWrap>
// 					<LineBox>
// 						<EditorBox dangerouslySetInnerHTML={{__html: notice?.poliInfo}} />
// 					</LineBox>
// 				</>
// 			)}
// 		</>
// 	);
// };

// /**
//  * 약관 / 취소수수료
//  */
// const TermsandCancellationFee = (props: {evCd: string}) => (
// 	<ErrorBoundary logMsg="ReferTabs TermsAndCancellationFee Error">
// 		<TermsAndCancellationFeeComponent {...props} />
// 	</ErrorBoundary>
// );

const PassportAndVisaComponent = ({evCd}: {evCd: string}) => {
	const useNotice = useEventNotice(evCd);
	const notice = useNotice.data?.body;

	return (
		<>
			{notice?.passportInfo && (
				<>
					<SubTitleWrap>
						<SubTitle>여권/비자</SubTitle>
					</SubTitleWrap>
					<LineBox>
						<EditorBox dangerouslySetInnerHTML={{__html: notice?.passportInfo}} />
					</LineBox>
				</>
			)}
		</>
	);
};

/**
 * 여권/비자
 */
const PassportandVisa = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="ReferTabs PassportAndVisa Error">
		<PassportAndVisaComponent {...props} />
	</ErrorBoundary>
);

const SafetyComponent = ({isButton = true, evCd}: {isButton: boolean; evCd: string}) => (
	<>
		<SubTitleWrap>
			<SubTitle>해외여행 안전정보</SubTitle>
		</SubTitleWrap>
		<LineBox>
			외교부에서는 [여행경보제도]를 운영하고 있으며, 노랑풍선은 고객님의 안전한 해외여행을 위하여 이 정보를 제공하고
			있습니다. 여행경보단계는 여행유의/자제/철수권고/금지 4단계로 구분되며,
			<br />
			단기적인 위험상황이 발생하는 경우 특별여행주의보/경보 2단계로 추가 구분하고 있습니다.
			<br />
			외교부에서 국가별 상황에 따라 상시로 [여행경보제도]의 변경이 있을 수 있으므로, 당사에서 제공하는 안전 정보가
			시점에 따라
			<br />
			다소 차이가 발생할 수 있사오니, 반드시 출국 전 여행목적지의(국가 및 지역,
			<a href={"https://www.0404.go.kr/ntnSafetyInfo/list"} target="_blank" rel="noreferrer">
				www.0404.go.kr
			</a>
			) 안전정보를 확인하시어
			<br />
			[외교부의 권고]를 따라 주시기 바랍니다.
			{isButton && (
				<style.InsuranceLink href="https://pkg.ybtour.co.kr/cs/travelSafetyGuide.yb" target="_blank">
					여행 안전 유의사항 자세히 보기
				</style.InsuranceLink>
			)}
		</LineBox>

		{/* 현지 정보 / 통화 관련  */}
		{evCd && <DetailLocalInformation evCd={evCd} />}
	</>
);

/**
 * 해외여행 안전정보
 */
const Safety = (props: {isButton: boolean; evCd: string}) => (
	<ErrorBoundary logMsg="ReferTabs Safety Error">
		<SafetyComponent {...props} />
	</ErrorBoundary>
);

const InsuranceComponent = ({evCd}: {evCd: string}) => {
	// const goodsTp = evCd?.substring(0, 1);
	const useInsurance = useEventInsurance(evCd);
	const insurance = useInsurance.data?.body;

	// const insuText = useMemo(() => (insurance?.insuType !== "S" ? "KB손해보험" : "삼성화재"), [insurance]);
	// const insuFileNm = useMemo(() => (insurance?.insuType !== "S" ? "KB" : "SAMSUNG_"), [insurance]);
	// const insuImg = useMemo(() => (insurance?.insuType !== "S" ? kbInsureImg : samsungInsureImg), [insurance]);

	// const ListContentRef = useRef([]);
	// const [expandedIndexes, setExpandedIndexes] = useState([]);
	// const handleToggle = (index: number) => {
	// 	setExpandedIndexes(prevIndexes =>
	// 		prevIndexes.includes(index) ? prevIndexes.filter(item => item !== index) : [...prevIndexes, index],
	// 	);
	// };

	return (
		<>
			{/* 보험 */}
			{insurance?.atteInfo && (
				<>
					<style.TitArea>
						<style.TermsDownloadArea>
							<SubTitle>보험</SubTitle>
							{/* <style.TextButton
								onClick={() => {
									window.open(
										`${publicRuntimeConfig.ENV_STATIC_CDN_URL}/document/TermsAndConditions/${
											goodsTp === "K" ? `${insuFileNm}dmt` : `${insuFileNm}pkg`
										}.pdf`,
									);
								}}
							>
								약관 다운로드
							</style.TextButton> */}
						</style.TermsDownloadArea>
						{/* <InsuranceImg src={insuImg} alt={insuText} /> */}
					</style.TitArea>
					<LineBox>
						<EditorBox dangerouslySetInnerHTML={{__html: insurance.atteInfo}} />
					</LineBox>
					<style.InsuranceLink
						href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/travelerInsuInfo.yb`}
						target="_blank"
						onClick={e => onClickSSO(e, `${publicRuntimeConfig.ENV_PACKAGE_URL}/common/travelerInsuInfo.yb`)}
					>
						여행자보험 보상한도, 보상기준, 보험약관 자세히 보기
					</style.InsuranceLink>
				</>
			)}

			{/* <style.List> */}
			{/* {insurance?.rewordId && (
					<style.ListItem>
						<style.ListContent onClick={() => handleToggle(0)} isActive={expandedIndexes.includes(0)}>
							<SubTitle>보상한도</SubTitle>
							<style.MoreButton isActive={expandedIndexes.includes(0)}>
								<span>더보기</span>
							</style.MoreButton>
						</style.ListContent>
						<style.ListDetail
							contentHeight={ListContentRef.current[0]?.clientHeight + 50}
							isActive={expandedIndexes.includes(0)}
						>
							<style.TermsContentWrap ref={el => (ListContentRef.current[0] = el)}>
								<Component rewordId={insurance.rewordId} />
							</style.TermsContentWrap>
						</style.ListDetail>
					</style.ListItem>
				)} */}
			{/* 해외 보상기준 삼성화재 */}
			{/* 국내 보상기준 삼성화재 */}
			{/* 해외 보상기준 KB */}
			{/* 국내 보상기준 KB */}
			{/* <style.ListItem>
					<style.ListContent onClick={() => handleToggle(1)} isActive={expandedIndexes.includes(1)}>
						<SubTitle>보상기준</SubTitle>
						<style.MoreButton isActive={expandedIndexes.includes(1)}>
							<span>더보기</span>
						</style.MoreButton>
					</style.ListContent>
					<style.ListDetail
						contentHeight={ListContentRef.current[1]?.clientHeight + 50}
						isActive={expandedIndexes.includes(1)}
					>
						<div ref={el => (ListContentRef.current[1] = el)}>
							{goodsTp !== "K" && insurance?.insuType === "S" && <SamsungPkg />}
							{goodsTp === "K" && insurance?.insuType === "S" && <SamsungDmt />}
							{goodsTp !== "K" && insurance?.insuType === "K" && <KBPkg />}
							{goodsTp === "K" && insurance?.insuType === "K" && <KBDmt />}
						</div>
					</style.ListDetail>
				</style.ListItem> */}

			{/* 삼성화재 필수안내사항 */}
			{/* {insurance?.insuType === "S" && (
					<style.ListItem>
						<style.ListContent onClick={() => handleToggle(2)} isActive={expandedIndexes.includes(2)}>
							<SubTitle>필수안내사항</SubTitle>
							<style.MoreButton isActive={expandedIndexes.includes(2)}>
								<span>더보기</span>
							</style.MoreButton>
						</style.ListContent>
						<style.ListDetail
							contentHeight={ListContentRef.current[2]?.clientHeight + 50}
							isActive={expandedIndexes.includes(2)}
						>
							<div ref={el => (ListContentRef.current[2] = el)}>
								<SamsungGuide />
							</div>
						</style.ListDetail>
					</style.ListItem>
				)} */}
			{/* </style.List> */}
		</>
	);
};

/**
 * 여행자 보험
 */
const Insurance = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="ReferTabs Insurance Error">
		<InsuranceComponent {...props} />
	</ErrorBoundary>
);

export {Importance, Insurance, Notice, PassportandVisa, Refer, Safety};
